export const USER_PROFILE_ENDPOINTS = {
    USER_PROFILE: '/api/v1/users/profile',
};


export enum UserProfileEndpointQueryKey {
    USER_PROFILE = 'user-profile'
}
